const basePath = ({ organizationId }) => `/sysconfig/api/v1/organizations/${organizationId}/org_units`;
const unprivilegedPath = ({ organizationId }) => `/api/v1/org_units/organizations/${organizationId}`;
export const ORG_UNITS_ROUTES = {
  GET: unprivilegedPath,
  CREATE: basePath,
  UPDATE: ({ unitId, organizationId }) => `${basePath({ organizationId })}/${unitId}`,
  DELETE: ({ unitId, organizationId }) => `${basePath({ organizationId })}/${unitId}`,
  SET_ACTIVE: ({ unitId, organizationId }) => `${basePath({ organizationId })}/${unitId}/set_active`,
  RELATED_CONFIGURATIONS: ({ unitId, organizationId }) =>
    `${basePath({ organizationId })}/${unitId}/related_configurations`,
};
